import { logOut } from "../../lib/druid";

export default function useValidateAtiveSession(){

  const validate = () => {
    const startSessionValidation = localStorage.getItem('start_session_validation');
    const currentTime = new Date().getTime();
    const renewTime = 1 * 20 * 1000;

    if ((currentTime - startSessionValidation > renewTime) || !startSessionValidation) {
      fetch('/api/dru-id/validate-session', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        }
      })
      .then(response => response.json())
      .then((data) => {
        if (data.userStatus === 'EXPIRED') {
          logOut();
        }
      });

      localStorage.setItem('start_session_validation', currentTime);
    }
  }

  return {validate};
}